import { render, staticRenderFns } from "./TabelaCadastros.vue?vue&type=template&id=263c47a6"
import script from "./TabelaCadastros.vue?vue&type=script&lang=js"
export * from "./TabelaCadastros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports